import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a544135"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-container" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "navlogo" }
const _hoisted_4 = { class: "nav-right" }
const _hoisted_5 = { class: "select" }
const _hoisted_6 = { class: "drawer-content" }
const _hoisted_7 = {
  class: "a",
  target: "_blank",
  href: "https://www.zhipin.com/gongsi/116b4325cefd01781XF_2N-4GVM~.html?from=top-card"
}
const _hoisted_8 = {
  class: "a",
  target: "_blank",
  href: "https://rekeymed.com/ram/admin/"
}

import { ref } from "vue";
import { useRouter } from "vue-router";
import { useNav } from "./useNav";

const direction = "ttb";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavView',
  setup(__props) {

const {
  SelectSubItem,
  handleSelect,
  activeIndex,
  isCollapse,
  ellipsis,
  navWidth,
  locale,
  changeLang,
  changeHref,
  langs,
  productNav,
  isDrawerVisible,
} = useNav();
const router = useRouter();
const goToHome = () => {
  router.push("/");
};

const handleClose = () => {
  isDrawerVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("img", {
              class: "navlogoimg",
              onClick: goToHome
            }, null, 512), [
              [_directive_lazy, require('@/assets/LOGO.png')]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.$i18n.locale,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
                onChange: _unref(changeLang)
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langs), (lang, i) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: lang.show,
                      key: `Lang${i}`,
                      value: lang.locale
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createVNode(_component_el_button, {
              class: "menu-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isDrawerVisible.value = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { color: "#004f9b" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Menu)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_drawer, {
      modelValue: _unref(isDrawerVisible),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isDrawerVisible) ? (isDrawerVisible).value = $event : null)),
      class: "drawer",
      direction: direction,
      "before-close": handleClose,
      "show-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_menu, {
            "text-color": "#333",
            "active-text-color": "#3270ad",
            "default-active": _unref(activeIndex),
            class: "drawer-menu",
            onSelect: _unref(handleSelect)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Home Page")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/about" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("About us")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "/product" }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Product Center")), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productNav), (item) => {
                    return (_openBlock(), _createBlock(_component_el_menu_item, {
                      onClick: ($event: any) => (_unref(SelectSubItem)(item)),
                      index: '/product/' + item.nav_index,
                      key: item.nav_index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "index"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "/tech" }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Innovative Technology")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "/tech" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("TechPlatform")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/service" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("ServiceCenter")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "news" }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("News information")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "/companynews" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Company News")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/industrynews" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Industry News")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "contact" }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Contact us")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "/talent" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("talentDev")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('rekeyRecruit')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/contact" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Contact")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t("RAM System")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-active", "onSelect"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})